import { Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.Blue50};
  padding-right: 4px;
  transition: color 0.1s ease-out;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: ${Colors.Blue60};
  }
`
